import { z } from 'zod';
import { DOMAINS, PUBLIC_MESSAGE_KINDS } from './referentiels-metier';
export const TYPES_COMMUNICATION = {
  CONFIRMED_OUTAGE: 'Interruption confirmée',
  PLANNED_OUTAGE: 'Coupure programmée',
  RESTORATION: 'Rétablissement',
  SAFETY: 'Consignes de sécurité',
} as const;
export const schemaCommunicationReseau = z
  .object({
    type: z.enum(PUBLIC_MESSAGE_KINDS),
    domaine: z.enum(DOMAINS),
    province_id: z.string().uuid(),
    titre: z.string().trim().min(5).max(150),
    contenu: z.string().trim().min(10).max(3000),
    incident_id: z.string().uuid().nullable().default(null),
    debut: z.string().datetime().nullable().default(null),
    fin: z.string().datetime().nullable().default(null),
  })
  .strict()
  .superRefine((d, c) => {
    if (d.type === 'PLANNED_OUTAGE' && (!d.debut || !d.fin))
      c.addIssue({ code: 'custom', message: 'La coupure programmée exige un début et une fin' });
    if (d.debut && d.fin && Date.parse(d.fin) <= Date.parse(d.debut))
      c.addIssue({ code: 'custom', message: 'La fin doit être postérieure au début' });
    if (['CONFIRMED_OUTAGE', 'RESTORATION'].includes(d.type) && !d.incident_id)
      c.addIssue({ code: 'custom', message: 'Un incident confirmé est requis' });
  });
export const schemaDecisionCommunication = z
  .object({
    action: z.enum(['publier', 'rejeter', 'archiver']),
    version: z.number().int().positive(),
    motif: z.string().trim().min(5).max(1000),
  })
  .strict();
